import React, { useState, useRef } from "react";
import { GoogleMap, LoadScript, Marker, InfoWindow } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "500px",
};

const PharmacyMap = ({ pharmacies }) => {
  const [hoveredInfo, setHoveredInfo] = useState(null);
  const hoverTimeout = useRef(null);

  const center = pharmacies.length > 0
    ? {
        lat: pharmacies[0].geometry.location.lat,
        lng: pharmacies[0].geometry.location.lng,
      }
    : { lat: 17.385044, lng: 78.486671 };

  const handleMouseOver = (pharmacy) => {
    clearTimeout(hoverTimeout.current);
    setHoveredInfo({
      lat: pharmacy.geometry.location.lat,
      lng: pharmacy.geometry.location.lng,
      name: pharmacy.name,
      address: pharmacy.formatted_address || pharmacy.vicinity,
    });
  };

  const handleMouseOut = () => {
    hoverTimeout.current = setTimeout(() => {
      setHoveredInfo(null);
    }, 200); // delay to avoid flicker
  };

  return (
    <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
      <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={14}>
        {pharmacies.map((pharmacy, index) => {
          const pos = {
            lat: pharmacy.geometry.location.lat,
            lng: pharmacy.geometry.location.lng,
          };

          return (
            <Marker
              key={index}
              position={pos}
              onMouseOver={() => handleMouseOver(pharmacy)}
              onMouseOut={handleMouseOut}
            />
          );
        })}

        {hoveredInfo && (
          <InfoWindow
            position={{ lat: hoveredInfo.lat, lng: hoveredInfo.lng }}
            onCloseClick={() => setHoveredInfo(null)}
            options={{ pixelOffset: new window.google.maps.Size(0, -40) }}
          >
            <div
              onMouseEnter={() => clearTimeout(hoverTimeout.current)}
              onMouseLeave={handleMouseOut}
              style={{ maxWidth: 200 }}
            >
              <strong>{hoveredInfo.name}</strong>
              <br />
              {hoveredInfo.address}
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
    </LoadScript>
  );
};

export default PharmacyMap;